export default "__VITE_ASSET__DAB1SEL0__"